import api from './api';

export interface VariacaoItem {
  id: number;
  nome: string;
  exames_count: number;
}

export interface ExameClinicoItem {
  id: number;
  nome: string;
  obrigatorio: boolean;
  preco: number;
  laboratorial: boolean;
  variacao_exame_clinico_id: number;
}

class VariacoesService {
  /**
   * Lista todas as variações (atividades complementares) disponíveis
   */
  async getVariacoes(): Promise<VariacaoItem[]> {
    const response = await api.get<VariacaoItem[]>('/exames/variacoes');
    return response.data;
  }

  /**
   * Lista exames clínicos disponíveis para uma variação e clínica
   */
  async getExamesClinicosPorVariacaoClinica(
    variacaoId: number,
    clinicaId: number
  ): Promise<ExameClinicoItem[]> {
    const response = await api.get<ExameClinicoItem[]>(
      `/exames/exames-clinicos/variacao/${variacaoId}/clinica/${clinicaId}`
    );
    return response.data;
  }

  /**
   * Vincula/desvincula exame clínico a um colaborador
   */
  async vincularExameClinicoColaborador(
    colaboradorId: number,
    exameClinicoId: number,
    variacaoId: number,
    clinicaId: number | undefined,
    vincular: boolean
  ): Promise<any> {
    const response = await api.post(
      `/exames/colaborador/${colaboradorId}/exame-clinico`,
      {
        exame_clinico_id: exameClinicoId,
        variacao_id: variacaoId,
        clinica_id: clinicaId,
        vincular,
      }
    );
    return response.data;
  }
}

export const variacoesService = new VariacoesService();

